// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"9":"static","501":"administration","675":"extra","779":"error","964":"product"}[chunkId] + "." + {"9":"acd5bc94","501":"4676563c","675":"a6ff04dd","779":"cadef2a9","964":"af7b0f9e"}[chunkId] + ".css";
};